module.exports = __webpack_public_path__ + "static/media/email-icon-error.00906f85.png";